module.exports = __webpack_public_path__ + "static/media/home_carrucel3.ea9ec962.png";